'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock from "./io.intela.sites.intelacloud.ui.-Markdown$-Block.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph(text) {
  this.ih = null;
  this.ih = text;
}
export { $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph as $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph };
$p = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph.prototype = new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock.$h_Lio_intela_sites_intelacloud_ui_Markdown$Block();
$p.constructor = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph() {
}
export { $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph as $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph };
$h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph.prototype = $p;
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1972255967), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph) && (this.ih === x$0.ih)));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "Paragraph";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.ih;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bP)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph as $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph };
var $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph, "io.intela.sites.intelacloud.ui.Markdown$Block$Paragraph", ({
  bP: 1,
  aJ: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph as $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Paragraph };
//# sourceMappingURL=io.intela.sites.intelacloud.ui.-Markdown$-Block$-Paragraph.js.map
